import { rgba } from 'polished'
import { css } from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const glassBackground = (color: string, transparency = 0.5, blur = '0.5rem') => css`
  background-color: ${rgba(color, transparency * 1.8)};

  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background-color: ${rgba(color, transparency)};
    backdrop-filter: blur(${blur});
  }
`
